import { useState } from "react";
import { usePortfolioGroupVersionStatData } from "../../usePortfolioGroupVersionStatData";
import { usePortfolioGroupParams } from "@app/hooks/usePortfolioGroupParams";
import { usePortfolioGroupInfo } from "../../usePortfolioGroupInfo";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { CarPageContentCode, usePageContent } from "@app/hooks/usePageContent";
import { CarPageContent } from "@app/components/PageContent";
import { ChartSimulatedForwardProbabilities } from "./../ChartSimulatedForwardProbabilities";
import { AnalyzeModuleStyledPage } from "./AnalyzeModuleStyledPage";
import { useAnalyzeModuleChartDataSelector } from "./useAnalyzeModuleChartDataSelector";
import {
  assetAllocationPages,
  portfolioAnalysisPages,
} from "@app/const/route.const";
import { CarDownloadButton } from "@app/components/Buttons";
import { openInNewTab } from "@app/utils";
import { UsePortfolioGroupVersionDataParams } from "../../usePortfolioGroupVersionData";

interface AnalyzeModuleSimulatedForwardProbabilitiesProps {
  versionParams: UsePortfolioGroupVersionDataParams;
  moduleId: string;
}

export const AnalyzeModuleSimulatedForwardProbabilities = (
  props: AnalyzeModuleSimulatedForwardProbabilitiesProps,
) => {
  const { portfolioGroupId } = usePortfolioGroupParams();

  const pageContent = usePageContent();

  const { moduleId } = props;

  const groupInfo = usePortfolioGroupInfo({ portfolioGroupId });

  const statData = usePortfolioGroupVersionStatData(props.versionParams);

  const defaultIds = statData.getDefaultDataIdsForModule(moduleId);

  const chartDataSelector = useAnalyzeModuleChartDataSelector({
    portfolioGroupVersionId: props.versionParams.versionId,
    ...defaultIds,
  });

  const [isReal, setIsReal] = useState(false);
  const [isCompare, setIsCompare] = useState(false);
  const [chartDateRange1, setChartDateRange1] = useState(20);
  const [chartDateRange2, setChartDateRange2] = useState(20);

  const handleShowPdf = () => {
    if (chartDataSelector.data1Id && chartDataSelector.data2Id) {
      const params = {
        portfolioGroupId,
        moduleId,
        data1Id: chartDataSelector.data1Id,
        data2Id: chartDataSelector.data2Id,
        isReal,
        isCompare,
        chartDateRange1,
        chartDateRange2,
      };

      openInNewTab(
        groupInfo.isSinglePortfolioMode
          ? portfolioAnalysisPages.getPdfSimulatedForwardProbabilitiesReportUrl(
              params,
            )
          : assetAllocationPages.getPdfModuleSimulatedForwardProbabilitiesReportUrl(
              params,
            ),
      );
    }
  };

  return (
    <AnalyzeModuleStyledPage>
      <TablePlaceHolder
        isLoading={
          groupInfo.isLoading || statData.isLoading || pageContent.isLoading
        }
        rows={5}
      >
        <CarPageContent
          isWhiteContext
          content={pageContent.getContent(
            groupInfo.isSinglePortfolioMode
              ? CarPageContentCode.PORTFOLIO_ANALYSIS_ANALYZE_SIMULATED_FORWARD_PROBABILITY
              : CarPageContentCode.ANALYZE_PORTFOLIO_GROUP_REPORTS_MODULE_FORWARD_PROJECTIONS,
          )}
        />
        <CarDownloadButton
          onClick={handleShowPdf}
          sx={{ my: 2, zIndex: 1, ml: "auto", alignSelf: "flex-end" }}
        >
          Download PDF
        </CarDownloadButton>
        <ChartSimulatedForwardProbabilities
          realHeatmap={statData.realHeatmap}
          nominalHeatmap={statData.nominalHeatmap}
          chartDataSelector={chartDataSelector}
          isReal={isReal}
          setIsReal={setIsReal}
          isCompare={isCompare}
          setIsCompare={setIsCompare}
          chartDateRange1={chartDateRange1}
          setChartDateRange1={setChartDateRange1}
          chartDateRange2={chartDateRange2}
          setChartDateRange2={setChartDateRange2}
        />
      </TablePlaceHolder>
    </AnalyzeModuleStyledPage>
  );
};
